"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gdColorDisabled = exports.gdColorStateBlank = void 0;
// (C) 2021-2022 GoodData Corporation
exports.gdColorStateBlank = "#94a1ad";
exports.gdColorDisabled = "#b0beca";
//# sourceMappingURL=colors.js.map